import React from "react";
import ContentLoader from "react-content-loader";

// Card skeleton for coupon cards, product cards, etc.
export const CouponCardSkeleton = ({ style = {} }) => (
  <div style={{ 
    ...style, 
    borderRadius: '16px', 
    overflow: 'hidden',
    background: 'white',
    padding: '16px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
    border: '1px solid rgba(254, 198, 111, 0.2)',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    boxSizing: 'border-box'
  }}>
    <ContentLoader
      speed={1.5}
      width={580}
      height={100}
      viewBox="0 0 580 100"
      backgroundColor="#f0f0f0"
      foregroundColor="#dedede"
      style={{ width: '100%', height: 'auto' }}
    >
      {/* Icon square (100x100) with gradient background effect */}
      <rect x="0" y="0" rx="14" ry="14" width="100" height="100" />
      {/* Inner icon (60x60) - slightly lighter to show the logo area */}
      <rect x="20" y="20" rx="8" ry="8" width="60" height="60" opacity="0.8" />
      
      {/* Separator line */}
      <rect x="120" y="10" rx="2" ry="2" width="2" height="80" />
      
      {/* Label */}
      <rect x="140" y="10" rx="3" ry="3" width="80" height="12" />
      
      {/* Title */}
      <rect x="140" y="32" rx="4" ry="4" width="220" height="18" />
      
      {/* Description line 1 */}
      <rect x="140" y="60" rx="3" ry="3" width="280" height="12" />
      
      {/* Description line 2 / Expiration */}
      <rect x="140" y="80" rx="3" ry="3" width="180" height="10" />
    </ContentLoader>
  </div>
);

// Product card skeleton
export const ProductCardSkeleton = ({ style = {} }) => (
  <div style={{ ...style, borderRadius: '16px', overflow: 'hidden', background: '#fff', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
    <ContentLoader
      speed={1.5}
      width={300}
      height={400}
      viewBox="0 0 300 400"
      backgroundColor="#f0f0f0"
      foregroundColor="#e0e0e0"
      style={{ width: '100%', height: '100%' }}
    >
      {/* Image area */}
      <rect x="0" y="0" rx="16" ry="16" width="300" height="200" />
      
      {/* Title */}
      <rect x="20" y="220" rx="4" ry="4" width="200" height="20" />
      
      {/* Description line 1 */}
      <rect x="20" y="255" rx="3" ry="3" width="260" height="12" />
      
      {/* Description line 2 */}
      <rect x="20" y="275" rx="3" ry="3" width="240" height="12" />
      
      {/* Price */}
      <rect x="20" y="310" rx="4" ry="4" width="100" height="24" />
      
      {/* Button */}
      <rect x="20" y="350" rx="25" ry="25" width="260" height="40" />
    </ContentLoader>
  </div>
);

// Generic card skeleton (flexible)
export const CardSkeleton = ({ width = 400, height = 200, style = {} }) => (
  <div style={{ ...style, borderRadius: '16px', overflow: 'hidden', background: '#fff', boxShadow: '0 2px 8px rgba(0,0,0,0.08)' }}>
    <ContentLoader
      speed={1.5}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      backgroundColor="#f0f0f0"
      foregroundColor="#e0e0e0"
      style={{ width: '100%', height: '100%' }}
    >
      <rect x="0" y="0" rx="16" ry="16" width={width} height={height} />
    </ContentLoader>
  </div>
);

// Coupon icon skeleton (for loading state)
export const CouponIconSkeleton = () => (
  <div style={{ 
    position: 'absolute', 
    top: '50%', 
    left: '50%', 
    transform: 'translate(-50%, -50%)' 
  }}>
    <ContentLoader
      speed={1.5}
      width={60}
      height={60}
      viewBox="0 0 60 60"
      backgroundColor="#e0e0e0"
      foregroundColor="#f5f5f5"
    >
      <rect x="0" y="0" rx="8" ry="8" width="60" height="60" />
    </ContentLoader>
  </div>
);

// List of skeleton cards
export const SkeletonList = ({ count = 3, Component = CouponCardSkeleton, containerStyle = {} }) => (
  <div style={containerStyle}>
    {Array.from({ length: count }).map((_, index) => (
      <Component key={index} />
    ))}
  </div>
);

// Order list item skeleton
export const OrderItemSkeleton = ({ style = {} }) => (
  <div style={{ ...style, borderRadius: '12px', overflow: 'hidden', marginBottom: '16px' }}>
    <ContentLoader
      speed={1.5}
      width={400}
      height={80}
      viewBox="0 0 400 80"
      backgroundColor="#f0f0f0"
      foregroundColor="#e0e0e0"
      style={{ width: '100%', height: '100%' }}
    >
      {/* Order reference */}
      <rect x="20" y="20" rx="4" ry="4" width="250" height="18" />
      
      {/* Date */}
      <rect x="20" y="48" rx="3" ry="3" width="150" height="14" />
      
      {/* Arrow icon */}
      <rect x="360" y="30" rx="2" ry="2" width="20" height="20" />
    </ContentLoader>
  </div>
);
export const PointsSkeleton = () => (
  <div style={{
    background: '#fff',
    borderRadius: '8px',
    margin: '10px 0',
    overflow: 'hidden',
    height: '70px',
    boxSizing: 'border-box',
    border: '1px solid #e8e8e8',
  }}>
    <ContentLoader
      speed={1.5}
      width="100%"
      height="70"
      viewBox="0 0 400 70"
      backgroundColor="#f0f0f0"
      foregroundColor="#e0e0e0"
      preserveAspectRatio="none"
      style={{ width: '100%', height: '70px', display: 'block' }}
    >
      {/* Main points line */}
      <rect x="80" y="16" rx="4" ry="4" width="240" height="16" />
      {/* Sub line */}
      <rect x="100" y="44" rx="3" ry="3" width="200" height="12" />
    </ContentLoader>
  </div>
);

export const FormSkeleton = () => (
  <div style={{
    width: 'calc(100% - 20px)',
    margin: '10px 10px 0 10px',
    padding: '16px',
    border: '1px solid #ccc',
    borderRadius: '16px',
    background: '#fff',
    boxSizing: 'border-box',
    overflow: 'hidden',
    height: '318px',
  }}>
    <ContentLoader
      speed={1.5}
      width="100%"
      height="286"
      viewBox="0 0 400 286"
      backgroundColor="#f0f0f0"
      foregroundColor="#e0e0e0"
      preserveAspectRatio="none"
      style={{ width: '100%', height: '286px', display: 'block' }}
    >
      {/* Navn label + input */}
      <rect x="0" y="0" rx="3" ry="3" width="50" height="14" />
      <rect x="0" y="20" rx="10" ry="10" width="400" height="46" />
      {/* E-post label + input */}
      <rect x="0" y="82" rx="3" ry="3" width="60" height="14" />
      <rect x="0" y="102" rx="10" ry="10" width="400" height="46" />
      {/* Mobil label + input */}
      <rect x="0" y="164" rx="3" ry="3" width="45" height="14" />
      <rect x="0" y="184" rx="10" ry="10" width="400" height="46" />
      {/* Betal button */}
      <rect x="0" y="246" rx="14" ry="14" width="400" height="40" />
    </ContentLoader>
  </div>
);

// Matches the dark navy design system (Profile.css) instead of a light-mode
// gray shimmer, using the same .skeleton-shimmer gradient Products.jsx uses.
export const ProfileSkeleton = () => (
  <div className="profile-wrapper">
    <div className="profile-scroll">
      {/* Hero */}
      <div className="profile-hero">
        <div className="skeleton-shimmer" style={{ width: 72, height: 72, borderRadius: '50%' }} />
        <div className="skeleton-shimmer" style={{ width: 140, height: 20, borderRadius: 6 }} />
        <div className="skeleton-shimmer" style={{ width: 90, height: 20, borderRadius: 20 }} />
      </div>

      {/* Points */}
      <div className="profile-points-card">
        <div className="skeleton-shimmer" style={{ width: 80, height: 12, borderRadius: 4 }} />
        <div className="skeleton-shimmer" style={{ width: 120, height: 28, borderRadius: 6 }} />
        <div className="skeleton-shimmer" style={{ width: 180, height: 12, borderRadius: 4 }} />
      </div>

      {/* Mine ting */}
      <div className="skeleton-shimmer" style={{ width: 90, height: 11, borderRadius: 4, margin: '4px 0' }} />
      <div className="profile-menu-card">
        {Array.from({ length: 4 }).map((_, i) => (
          <div key={i} className="profile-menu-row">
            <div className="skeleton-shimmer" style={{ width: 36, height: 36, borderRadius: 9, flexShrink: 0 }} />
            <div className="profile-menu-text">
              <div className="skeleton-shimmer" style={{ width: '55%', height: 14, borderRadius: 4, marginBottom: 6 }} />
              <div className="skeleton-shimmer" style={{ width: '75%', height: 11, borderRadius: 4 }} />
            </div>
          </div>
        ))}
      </div>

      {/* Support & konto */}
      <div className="skeleton-shimmer" style={{ width: 130, height: 11, borderRadius: 4, margin: '4px 0' }} />
      <div className="profile-menu-card">
        {Array.from({ length: 2 }).map((_, i) => (
          <div key={i} className="profile-menu-row">
            <div className="skeleton-shimmer" style={{ width: 36, height: 36, borderRadius: 9, flexShrink: 0 }} />
            <div className="profile-menu-text">
              <div className="skeleton-shimmer" style={{ width: '55%', height: 14, borderRadius: 4, marginBottom: 6 }} />
              <div className="skeleton-shimmer" style={{ width: '75%', height: 11, borderRadius: 4 }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export const BannerSkeleton = () => (
  <div style={{
    width: 'calc(100% - 20px)',
    margin: '10px auto 0 auto',
    borderRadius: '14px',
    overflow: 'hidden',
    border: '2px solid #fec76f',
    background: '#fff',
    boxSizing: 'border-box',
    height: '66px',
  }}>
    <ContentLoader
      speed={1.5}
      width="100%"
      height="66"
      viewBox="0 0 400 66"
      backgroundColor="#f0f0f0"
      foregroundColor="#e0e0e0"
      preserveAspectRatio="none"
      style={{ width: '100%', height: '66px', display: 'block' }}
    >
      {/* Icon circle */}
      <circle cx="30" cy="33" r="10" />
      {/* Name bar */}
      <rect x="50" y="24" rx="4" ry="4" width="110" height="18" />
      {/* Badge pill on right */}
      <rect x="300" y="22" rx="10" ry="10" width="80" height="22" />
    </ContentLoader>
  </div>
);